import { hyperdbTriggers } from 'hyperdb-utils';
import config from '../config';

const triggers = hyperdbTriggers({ config,
  triggerName: 'customer',
  namespace: 'CUSTOMER',
  entryPoint: '/customers',
  collectionName: 'customers',
  querySearchListing: [
    ['name', 'client_id', 'domain_name', 'registration_date', 'expiry_date', 'active'],
    { order: { id: 'asc' } }
  ],
  quickSearch: (keyword) => ({ $any: [{ name: { match: keyword } }, { 'client_id': { match: keyword } }] }),
  successMessageCreate: 'Customer created',
  successMessageUpdate: 'Customer updated',
  successMessageDelete: 'Customer deleted',
});

export default {
  ...triggers,
};



// WEBPACK FOOTER //
// ./src/frontend/admin/customer/triggers.js